export default __webpack_public_path__ + "static/img_3_1-e507e91188c516233718d1d015091c82.jpg";